var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryVehicleLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3471 5.52447V4H12.2194V5.52447H7.78063V4H5.65217V5.52447H4V16H16V5.52447H14.3471ZM5.17933 14.2235V7.30094H14.8207V14.2235H5.17933Z",
    fill: "#F79009"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.3529H8V9.64706H6V10.3529Z",
    fill: "#F79009"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3879 8.94118H12.6127V9.58974H12V10.4103H12.6127V11.0588H13.3879V10.4103H14V9.58974H13.3879V8.94118Z",
    fill: "#F79009"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryVehicleLow);
export default __webpack_public_path__ + "static/media/battery-vehicle-low.f5bacc345d7bd4256a4c6b18b604a46a.svg";
export { ForwardRef as ReactComponent };